export const DOCUMENT_TITLE = 'Document Title (visible only for you)';